module.exports = __webpack_public_path__ + "static/media/3D打印灯光电子琴.5fe42ec5.png";